var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details-sheet',_vm._b({attrs:{"item":_vm.device,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.date_registration",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("dateFormat")(item.date_registration))+"\n  ")]}}])},'details-sheet',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }